import Vue from 'vue';
import Vuex from 'vuex';
import createWebSocketPlugin from '@/plugins/websocket';
import { IBitfinexState } from './modules/bitfinex';
import { IBitflyerState } from './modules/bitflyer';
import { IBitMexState } from './modules/bitmex';
import { IExchangeTradesState } from './modules/exchangeTrades';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

interface StoreType {
  bitfinex: IBitfinexState;
  bitflyer: IBitflyerState;
  bitmex: IBitMexState;
  exchangeTrades: IExchangeTradesState;
}

export default new Vuex.Store<StoreType>({
  plugins: [createWebSocketPlugin()],
  strict: debug,
});
